//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class BulkClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Emails were sent
     */
    passwordReset(passwordResetRequest: PasswordResetRequest, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/cp/users/bulk/password-reset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(passwordResetRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPasswordReset(_response);
        });
    }

    protected processPasswordReset(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return Users with associated emails were removed
     */
    remove(removeUsersRequest: RemoveUsersRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/bulk/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(removeUsersRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    findBulkUsers(bulkUserRequest: FindBulkUsersRequest, cancelToken?: CancelToken): Promise<FindBulkUsersResponse> {
        let url_ = this.baseUrl + "/api/cp/users/bulk/users/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkUserRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindBulkUsers(_response);
        });
    }

    protected processFindBulkUsers(response: AxiosResponse): Promise<FindBulkUsersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FindBulkUsersResponse.fromJS(resultData200);
            return Promise.resolve<FindBulkUsersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FindBulkUsersResponse>(null as any);
    }

    /**
     * @param contentType (optional) 
     * @param contentDisposition (optional) 
     * @param headers (optional) 
     * @param length (optional) 
     * @param name (optional) 
     * @param fileName (optional) 
     * @param includeInvited (optional) 
     * @return File was parsed and emails were validated
     */
    validateInvitationsFile(contentType: string | null | undefined, contentDisposition: string | null | undefined, headers: any[] | null | undefined, length: number | undefined, name: string | null | undefined, fileName: string | null | undefined, includeInvited: boolean | null | undefined, cancelToken?: CancelToken): Promise<BulkInvitationValidationResult> {
        let url_ = this.baseUrl + "/api/cp/users/bulk/invitations/validate-file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new globalThis.Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());
        if (includeInvited !== null && includeInvited !== undefined)
            content_.append("includeInvited", includeInvited.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateInvitationsFile(_response);
        });
    }

    protected processValidateInvitationsFile(response: AxiosResponse): Promise<BulkInvitationValidationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BulkInvitationValidationResult.fromJS(resultData200);
            return Promise.resolve<BulkInvitationValidationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BulkInvitationValidationResult>(null as any);
    }

    /**
     * @return Invitations were sent
     */
    sendBulkInvitations(request: SendBulkInvitesRequest, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/cp/users/bulk/invitations/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendBulkInvitations(_response);
        });
    }

    protected processSendBulkInvitations(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("No valid emails to send invitations", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return Bulk email job status retrieved
     */
    getBulkEmailJobStatus(jobId: number, cancelToken?: CancelToken): Promise<BulkEmailJobStatusResponse> {
        let url_ = this.baseUrl + "/api/cp/users/bulk/jobs/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBulkEmailJobStatus(_response);
        });
    }

    protected processGetBulkEmailJobStatus(response: AxiosResponse): Promise<BulkEmailJobStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BulkEmailJobStatusResponse.fromJS(resultData200);
            return Promise.resolve<BulkEmailJobStatusResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Bulk email job not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BulkEmailJobStatusResponse>(null as any);
    }
}

export class InviteEmailClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Renders the invite email to HTML for the tenant-settings preview, using the same template
    and placeholder pipeline as the real send. Tenant branding (logo/name/phone/email) is read
    server-side from settings; only the draft body comes from the request.
     * @return Rendered invite-email HTML
     */
    preview(request: InviteEmailPreviewRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/invite-email/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreview(_response);
        });
    }

    protected processPreview(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LegalAgreementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getStatus( cancelToken?: CancelToken): Promise<AgreementStatus> {
        let url_ = this.baseUrl + "/api/cp/users/legal-agreement/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatus(_response);
        });
    }

    protected processGetStatus(response: AxiosResponse): Promise<AgreementStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgreementStatus.fromJS(resultData200);
            return Promise.resolve<AgreementStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgreementStatus>(null as any);
    }

    getLatest( cancelToken?: CancelToken): Promise<Agreement> {
        let url_ = this.baseUrl + "/api/cp/users/legal-agreement";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatest(_response);
        });
    }

    protected processGetLatest(response: AxiosResponse): Promise<Agreement> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Agreement.fromJS(resultData200);
            return Promise.resolve<Agreement>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Agreement>(null as any);
    }

    /**
     * @return Acceptance recorded
     */
    accept(request: AcceptLegalAgreementRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/legal-agreement/accept";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccept(_response);
        });
    }

    protected processAccept(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LinkV2Client {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Link created
     */
    createLink(request: CreateLinkRequest, cancelToken?: CancelToken): Promise<CreateLinkResponse> {
        let url_ = this.baseUrl + "/api/cp/users/direct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLink(_response);
        });
    }

    protected processCreateLink(response: AxiosResponse): Promise<CreateLinkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateLinkResponse.fromJS(resultData200);
            return Promise.resolve<CreateLinkResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateLinkResponse>(null as any);
    }
}

export class UsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Authenticate a customer portal user with a Microsoft token
     * @param idToken JWT issued by Microsoft
     * @return Authentication was successful
     */
    authenticateWithMicrosoft(idToken: string, cancelToken?: CancelToken): Promise<SuccessfulAuthenticationResponse> {
        let url_ = this.baseUrl + "/api/cp/users/authenticate/microsoft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idToken);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticateWithMicrosoft(_response);
        });
    }

    protected processAuthenticateWithMicrosoft(response: AxiosResponse): Promise<SuccessfulAuthenticationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SuccessfulAuthenticationResponse.fromJS(resultData200);
            return Promise.resolve<SuccessfulAuthenticationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessfulAuthenticationResponse>(null as any);
    }

    /**
     * Authenticate a customer portal user with a Google token
     * @param idToken JWT issued by Google
     * @return Authentication was successful
     */
    authenticateWithGoogle(idToken: string, cancelToken?: CancelToken): Promise<SuccessfulAuthenticationResponse> {
        let url_ = this.baseUrl + "/api/cp/users/authenticate/google";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idToken);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticateWithGoogle(_response);
        });
    }

    protected processAuthenticateWithGoogle(response: AxiosResponse): Promise<SuccessfulAuthenticationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SuccessfulAuthenticationResponse.fromJS(resultData200);
            return Promise.resolve<SuccessfulAuthenticationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessfulAuthenticationResponse>(null as any);
    }

    getGoogleOneTapIframeUrl( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/cp/users/google/iframe-url";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGoogleOneTapIframeUrl(_response);
        });
    }

    protected processGetGoogleOneTapIframeUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getMicrosoftAuthOptions( cancelToken?: CancelToken): Promise<MicrosoftAuthOptionsResponse> {
        let url_ = this.baseUrl + "/api/cp/users/microsoft/auth-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMicrosoftAuthOptions(_response);
        });
    }

    protected processGetMicrosoftAuthOptions(response: AxiosResponse): Promise<MicrosoftAuthOptionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MicrosoftAuthOptionsResponse.fromJS(resultData200);
            return Promise.resolve<MicrosoftAuthOptionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MicrosoftAuthOptionsResponse>(null as any);
    }

    /**
     * Authenticate a customer portal user
     * @param authenticationInfo The login and password information
     * @return Authentication was successful
     */
    authenticate(authenticationInfo: AuthenticationInfo, cancelToken?: CancelToken): Promise<SuccessfulAuthenticationResponse> {
        let url_ = this.baseUrl + "/api/cp/users/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authenticationInfo);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: AxiosResponse): Promise<SuccessfulAuthenticationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SuccessfulAuthenticationResponse.fromJS(resultData200);
            return Promise.resolve<SuccessfulAuthenticationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessfulAuthenticationResponse>(null as any);
    }

    /**
     * Verify MFA code and complete authentication
     */
    verifyMfaCode(request: MfaVerificationRequest, cancelToken?: CancelToken): Promise<SuccessfulAuthenticationResponse> {
        let url_ = this.baseUrl + "/api/cp/users/authenticate/mfa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyMfaCode(_response);
        });
    }

    protected processVerifyMfaCode(response: AxiosResponse): Promise<SuccessfulAuthenticationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SuccessfulAuthenticationResponse.fromJS(resultData200);
            return Promise.resolve<SuccessfulAuthenticationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessfulAuthenticationResponse>(null as any);
    }

    /**
     * Resend MFA code (rate-limited). Uses opaque mfaSessionToken to resolve user.
     */
    resendMfaCode(request: ResendMfaCodeRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/cp/users/authenticate/mfa/resend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendMfaCode(_response);
        });
    }

    protected processResendMfaCode(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Validate authenticated customer portal user
     * @return User info is returned
     */
    validate( cancelToken?: CancelToken): Promise<UserInfo> {
        let url_ = this.baseUrl + "/api/cp/users/validate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidate(_response);
        });
    }

    protected processValidate(response: AxiosResponse): Promise<UserInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserInfo.fromJS(resultData200);
            return Promise.resolve<UserInfo>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("User is not authenticated", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("User is authenticated but info cannot be found or the user is inactive", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInfo>(null as any);
    }

    /**
     * Log out authenticated user
     * @return User is signed out
     */
    logout( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Request to send invitation is accepted
     */
    invite(request: InviteRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/invitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvite(_response);
        });
    }

    protected processInvite(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Validation errors have occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Request to send invitation is accepted
     */
    selfInvite(request: InviteRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/invitation/self";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSelfInvite(_response);
        });
    }

    protected processSelfInvite(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Validation errors have occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Validates an invitation token
     * @param invitationToken Token
     * @return The invitation token was found
     */
    validateInvitationToken(invitationToken: string, cancelToken?: CancelToken): Promise<ValidatedInvitation> {
        let url_ = this.baseUrl + "/api/cp/users/invitation/{invitationToken}";
        if (invitationToken === undefined || invitationToken === null)
            throw new globalThis.Error("The parameter 'invitationToken' must be defined.");
        url_ = url_.replace("{invitationToken}", encodeURIComponent("" + invitationToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateInvitationToken(_response);
        });
    }

    protected processValidateInvitationToken(response: AxiosResponse): Promise<ValidatedInvitation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidatedInvitation.fromJS(resultData200);
            return Promise.resolve<ValidatedInvitation>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Invitation was found, but has already been fulfilled", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("The invitation token was not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidatedInvitation>(null as any);
    }

    /**
     * Registers a customer portal user through an invitation token
     * @param userTokenRegistration The information needed to register a user
     */
    register(userTokenRegistration: UserTokenRegistration, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userTokenRegistration);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("Validation errors occurred", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Invitation not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getInvitations(contactMethod: string[] | undefined, cancelToken?: CancelToken): Promise<CustomerInvitationResult> {
        let url_ = this.baseUrl + "/api/cp/users/invitations?";
        if (contactMethod === null)
            throw new globalThis.Error("The parameter 'contactMethod' cannot be null.");
        else if (contactMethod !== undefined)
            contactMethod && contactMethod.forEach(item => { url_ += "contactMethod=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvitations(_response);
        });
    }

    protected processGetInvitations(response: AxiosResponse): Promise<CustomerInvitationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerInvitationResult.fromJS(resultData200);
            return Promise.resolve<CustomerInvitationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerInvitationResult>(null as any);
    }

    /**
     * Performs a one-time migration of users from CP1 to CP2
     * @return Successfully migrated cp1 users
     */
    migrateCp1Users( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/migration/cp1";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMigrateCp1Users(_response);
        });
    }

    protected processMigrateCp1Users(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Successfully accepted request of the password reset link
     */
    sendPasswordResetLink(request: SendPasswordResetLinkRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/password-resets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendPasswordResetLink(_response);
        });
    }

    protected processSendPasswordResetLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Validation errors occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Successfully accepted request of the password reset link
     */
    selfSendPasswordResetLink(request: SendPasswordResetLinkRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/password-resets/self";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSelfSendPasswordResetLink(_response);
        });
    }

    protected processSelfSendPasswordResetLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Validation errors occurred", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Password reset token has not expired
     */
    validatePasswordResetToken(token: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/password-resets/{token}";
        if (token === undefined || token === null)
            throw new globalThis.Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidatePasswordResetToken(_response);
        });
    }

    protected processValidatePasswordResetToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Password token expired", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates the users password using a reset token
     * @param token The password reset token
     * @param newPasswordModel The data required to reset the password
     * @return Successfully updated the password
     */
    updatePassword(token: string, newPasswordModel: NewPasswordModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/passwords/{token}";
        if (token === undefined || token === null)
            throw new globalThis.Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newPasswordModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePassword(_response);
        });
    }

    protected processUpdatePassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("The new password does not match the requirements", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("The specified token is invalid", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userEmail (optional) 
     * @return Returned user permissions
     */
    getUserPermissionsByEmails(userEmail: string[] | undefined, cancelToken?: CancelToken): Promise<UserPermissionModelV2[]> {
        let url_ = this.baseUrl + "/api/cp/users/permissions/emails?";
        if (userEmail === null)
            throw new globalThis.Error("The parameter 'userEmail' cannot be null.");
        else if (userEmail !== undefined)
            userEmail && userEmail.forEach(item => { url_ += "userEmail=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserPermissionsByEmails(_response);
        });
    }

    protected processGetUserPermissionsByEmails(response: AxiosResponse): Promise<UserPermissionModelV2[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPermissionModelV2.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserPermissionModelV2[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("User not found by email", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPermissionModelV2[]>(null as any);
    }

    /**
     * @return Returned user permissions
     */
    getCurrentUserPermissions( cancelToken?: CancelToken): Promise<UserPermissionModelV2[]> {
        let url_ = this.baseUrl + "/api/cp/users/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUserPermissions(_response);
        });
    }

    protected processGetCurrentUserPermissions(response: AxiosResponse): Promise<UserPermissionModelV2[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPermissionModelV2.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserPermissionModelV2[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("User not found by email", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPermissionModelV2[]>(null as any);
    }

    /**
     * Resolves the caller's access context (accessible customer/location IDs plus tenant
    settings-based allow-lists) for an entity type in a single call — consolidates what
    would otherwise be GetCurrentUserPermissionsAsync plus a separate
    per-entity-type settings lookup into one round trip for monolith callers.
     * @return Resolved access context
     */
    accessContext(request: AccessContextRequestModel, cancelToken?: CancelToken): Promise<AccessContextResponseModel> {
        let url_ = this.baseUrl + "/api/cp/users/access-context";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccessContext(_response);
        });
    }

    protected processAccessContext(response: AxiosResponse): Promise<AccessContextResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessContextResponseModel.fromJS(resultData200);
            return Promise.resolve<AccessContextResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessContextResponseModel>(null as any);
    }

    checkPermission(permissionType: UserPermissionType | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/cp/users/permissions/check?";
        if (permissionType === null)
            throw new globalThis.Error("The parameter 'permissionType' cannot be null.");
        else if (permissionType !== undefined)
            url_ += "permissionType=" + encodeURIComponent("" + permissionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckPermission(_response);
        });
    }

    protected processCheckPermission(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param userEmail (optional) 
     * @param userPhone (optional) 
     * @return Returned user permissions
     */
    getCustomerPermissions(customerId: number, userEmail: string[] | undefined, userPhone: string[] | undefined, cancelToken?: CancelToken): Promise<UserPermissionModelV2[]> {
        let url_ = this.baseUrl + "/api/cp/users/permissions/customer/{customerId}?";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (userEmail === null)
            throw new globalThis.Error("The parameter 'userEmail' cannot be null.");
        else if (userEmail !== undefined)
            userEmail && userEmail.forEach(item => { url_ += "userEmail=" + encodeURIComponent("" + item) + "&"; });
        if (userPhone === null)
            throw new globalThis.Error("The parameter 'userPhone' cannot be null.");
        else if (userPhone !== undefined)
            userPhone && userPhone.forEach(item => { url_ += "userPhone=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerPermissions(_response);
        });
    }

    protected processGetCustomerPermissions(response: AxiosResponse): Promise<UserPermissionModelV2[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPermissionModelV2.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserPermissionModelV2[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPermissionModelV2[]>(null as any);
    }

    /**
     * @param userEmail (optional) 
     * @param userPhone (optional) 
     * @return Returned user permissions
     */
    getLocationPermissions(locationId: number, userEmail: string[] | undefined, userPhone: string[] | undefined, cancelToken?: CancelToken): Promise<UserPermissionModelV2[]> {
        let url_ = this.baseUrl + "/api/cp/users/permissions/location/{locationId}?";
        if (locationId === undefined || locationId === null)
            throw new globalThis.Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        if (userEmail === null)
            throw new globalThis.Error("The parameter 'userEmail' cannot be null.");
        else if (userEmail !== undefined)
            userEmail && userEmail.forEach(item => { url_ += "userEmail=" + encodeURIComponent("" + item) + "&"; });
        if (userPhone === null)
            throw new globalThis.Error("The parameter 'userPhone' cannot be null.");
        else if (userPhone !== undefined)
            userPhone && userPhone.forEach(item => { url_ += "userPhone=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocationPermissions(_response);
        });
    }

    protected processGetLocationPermissions(response: AxiosResponse): Promise<UserPermissionModelV2[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPermissionModelV2.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserPermissionModelV2[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPermissionModelV2[]>(null as any);
    }

    /**
     * @return Successfully updated user permissions
     */
    putPermissionsV2(permissions: UserPermissionModelV2[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/v2/permissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissions);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutPermissionsV2(_response);
        });
    }

    protected processPutPermissionsV2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userEmail (optional) 
     * @return User with email address no longer exists
     */
    removeUser(userEmail: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/cp/users/user?";
        if (userEmail === null)
            throw new globalThis.Error("The parameter 'userEmail' cannot be null.");
        else if (userEmail !== undefined)
            url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveUser(_response);
        });
    }

    protected processRemoveUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PasswordResetRequest implements IPasswordResetRequest {
    emails!: string[];

    constructor(data?: IPasswordResetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
        }
    }

    static fromJS(data: any): PasswordResetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordResetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        return data;
    }
}

export interface IPasswordResetRequest {
    emails: string[];
}

export class RemoveUsersRequest implements IRemoveUsersRequest {
    emails!: string[];

    constructor(data?: IRemoveUsersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
        }
    }

    static fromJS(data: any): RemoveUsersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveUsersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        return data;
    }
}

export interface IRemoveUsersRequest {
    emails: string[];
}

export class FindBulkUsersResponse implements IFindBulkUsersResponse {
    page!: number;
    pageSize!: number;
    hasMore!: boolean;
    totalCount!: number;
    data!: BulkUserData[];

    constructor(data?: IFindBulkUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.hasMore = _data["hasMore"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BulkUserData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FindBulkUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FindBulkUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["hasMore"] = this.hasMore;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFindBulkUsersResponse {
    page: number;
    pageSize: number;
    hasMore: boolean;
    totalCount: number;
    data: BulkUserData[];
}

export class BulkUserData implements IBulkUserData {
    email!: string;
    invitationStatus!: CustomerInvitationStatus;
    lastLogin!: Date | undefined;
    accountCreated!: Date | undefined;
    inviteSentData!: Date;
    associatedCustomers!: AssociatedCustomer[];

    constructor(data?: IBulkUserData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.invitationStatus = _data["invitationStatus"];
            this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : undefined as any;
            this.accountCreated = _data["accountCreated"] ? new Date(_data["accountCreated"].toString()) : undefined as any;
            this.inviteSentData = _data["inviteSentData"] ? new Date(_data["inviteSentData"].toString()) : undefined as any;
            if (Array.isArray(_data["associatedCustomers"])) {
                this.associatedCustomers = [] as any;
                for (let item of _data["associatedCustomers"])
                    this.associatedCustomers!.push(AssociatedCustomer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BulkUserData {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUserData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["invitationStatus"] = this.invitationStatus;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : undefined as any;
        data["accountCreated"] = this.accountCreated ? this.accountCreated.toISOString() : undefined as any;
        data["inviteSentData"] = this.inviteSentData ? this.inviteSentData.toISOString() : undefined as any;
        if (Array.isArray(this.associatedCustomers)) {
            data["associatedCustomers"] = [];
            for (let item of this.associatedCustomers)
                data["associatedCustomers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBulkUserData {
    email: string;
    invitationStatus: CustomerInvitationStatus;
    lastLogin: Date | undefined;
    accountCreated: Date | undefined;
    inviteSentData: Date;
    associatedCustomers: AssociatedCustomer[];
}

export enum CustomerInvitationStatus {
    Invited = 1,
    Active = 2,
    Expired = 3,
}

export class AssociatedCustomer implements IAssociatedCustomer {
    id!: number;
    name!: string;
    billingAccess!: UserPermissionType | undefined;
    contactExists!: boolean;
    locations!: AssociatedLocation[];

    constructor(data?: IAssociatedCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.billingAccess = _data["billingAccess"];
            this.contactExists = _data["contactExists"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(AssociatedLocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssociatedCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new AssociatedCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["billingAccess"] = this.billingAccess;
        data["contactExists"] = this.contactExists;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssociatedCustomer {
    id: number;
    name: string;
    billingAccess: UserPermissionType | undefined;
    contactExists: boolean;
    locations: AssociatedLocation[];
}

export enum UserPermissionType {
    None = 0,
    Read = 1,
    Billing = 2,
    InheritsFromCustomer = 3,
}

export class AssociatedLocation implements IAssociatedLocation {
    id!: number;
    name!: string;
    billingAccess!: UserPermissionType;

    constructor(data?: IAssociatedLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.billingAccess = _data["billingAccess"];
        }
    }

    static fromJS(data: any): AssociatedLocation {
        data = typeof data === 'object' ? data : {};
        let result = new AssociatedLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["billingAccess"] = this.billingAccess;
        return data;
    }
}

export interface IAssociatedLocation {
    id: number;
    name: string;
    billingAccess: UserPermissionType;
}

export class FindBulkUsersRequest implements IFindBulkUsersRequest {
    email!: string | undefined;
    customerEmails!: string[];
    locationEmails!: string[];
    inviteStatuses!: CustomerInvitationStatus[];
    accountCreationDate!: DateRange | undefined;
    dateLastInviteSent!: DateRange | undefined;
    lastLoginDate!: DateRange | undefined;
    options!: FindBulkUserOptions;

    constructor(data?: IFindBulkUsersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.options = new FindBulkUserOptions();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            if (Array.isArray(_data["customerEmails"])) {
                this.customerEmails = [] as any;
                for (let item of _data["customerEmails"])
                    this.customerEmails!.push(item);
            }
            if (Array.isArray(_data["locationEmails"])) {
                this.locationEmails = [] as any;
                for (let item of _data["locationEmails"])
                    this.locationEmails!.push(item);
            }
            if (Array.isArray(_data["inviteStatuses"])) {
                this.inviteStatuses = [] as any;
                for (let item of _data["inviteStatuses"])
                    this.inviteStatuses!.push(item);
            }
            this.accountCreationDate = _data["accountCreationDate"] ? DateRange.fromJS(_data["accountCreationDate"]) : undefined as any;
            this.dateLastInviteSent = _data["dateLastInviteSent"] ? DateRange.fromJS(_data["dateLastInviteSent"]) : undefined as any;
            this.lastLoginDate = _data["lastLoginDate"] ? DateRange.fromJS(_data["lastLoginDate"]) : undefined as any;
            this.options = _data["options"] ? FindBulkUserOptions.fromJS(_data["options"]) : new FindBulkUserOptions();
        }
    }

    static fromJS(data: any): FindBulkUsersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FindBulkUsersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        if (Array.isArray(this.customerEmails)) {
            data["customerEmails"] = [];
            for (let item of this.customerEmails)
                data["customerEmails"].push(item);
        }
        if (Array.isArray(this.locationEmails)) {
            data["locationEmails"] = [];
            for (let item of this.locationEmails)
                data["locationEmails"].push(item);
        }
        if (Array.isArray(this.inviteStatuses)) {
            data["inviteStatuses"] = [];
            for (let item of this.inviteStatuses)
                data["inviteStatuses"].push(item);
        }
        data["accountCreationDate"] = this.accountCreationDate ? this.accountCreationDate.toJSON() : undefined as any;
        data["dateLastInviteSent"] = this.dateLastInviteSent ? this.dateLastInviteSent.toJSON() : undefined as any;
        data["lastLoginDate"] = this.lastLoginDate ? this.lastLoginDate.toJSON() : undefined as any;
        data["options"] = this.options ? this.options.toJSON() : undefined as any;
        return data;
    }
}

export interface IFindBulkUsersRequest {
    email: string | undefined;
    customerEmails: string[];
    locationEmails: string[];
    inviteStatuses: CustomerInvitationStatus[];
    accountCreationDate: DateRange | undefined;
    dateLastInviteSent: DateRange | undefined;
    lastLoginDate: DateRange | undefined;
    options: FindBulkUserOptions;
}

export class DateRange implements IDateRange {
    from!: Date | undefined;
    to!: Date | undefined;

    constructor(data?: IDateRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DateRange {
        data = typeof data === 'object' ? data : {};
        let result = new DateRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : undefined as any;
        data["to"] = this.to ? this.to.toISOString() : undefined as any;
        return data;
    }
}

export interface IDateRange {
    from: Date | undefined;
    to: Date | undefined;
}

export class FindBulkUserOptions implements IFindBulkUserOptions {
    page!: number;
    pageSize!: number;
    orderBy!: BulkUserOrderBy | undefined;
    orderByDesc!: boolean;

    constructor(data?: IFindBulkUserOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.orderBy = _data["orderBy"];
            this.orderByDesc = _data["orderByDesc"];
        }
    }

    static fromJS(data: any): FindBulkUserOptions {
        data = typeof data === 'object' ? data : {};
        let result = new FindBulkUserOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["orderBy"] = this.orderBy;
        data["orderByDesc"] = this.orderByDesc;
        return data;
    }
}

export interface IFindBulkUserOptions {
    page: number;
    pageSize: number;
    orderBy: BulkUserOrderBy | undefined;
    orderByDesc: boolean;
}

export enum BulkUserOrderBy {
    Email = 0,
    Status = 1,
    LastLogin = 2,
}

export class BulkInvitationValidationResult implements IBulkInvitationValidationResult {
    validEmails!: string[];
    invalidEmails!: string[];
    totalEmailsParsed!: number;
    wasTruncated!: boolean;

    constructor(data?: IBulkInvitationValidationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["validEmails"])) {
                this.validEmails = [] as any;
                for (let item of _data["validEmails"])
                    this.validEmails!.push(item);
            }
            if (Array.isArray(_data["invalidEmails"])) {
                this.invalidEmails = [] as any;
                for (let item of _data["invalidEmails"])
                    this.invalidEmails!.push(item);
            }
            this.totalEmailsParsed = _data["totalEmailsParsed"];
            this.wasTruncated = _data["wasTruncated"];
        }
    }

    static fromJS(data: any): BulkInvitationValidationResult {
        data = typeof data === 'object' ? data : {};
        let result = new BulkInvitationValidationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validEmails)) {
            data["validEmails"] = [];
            for (let item of this.validEmails)
                data["validEmails"].push(item);
        }
        if (Array.isArray(this.invalidEmails)) {
            data["invalidEmails"] = [];
            for (let item of this.invalidEmails)
                data["invalidEmails"].push(item);
        }
        data["totalEmailsParsed"] = this.totalEmailsParsed;
        data["wasTruncated"] = this.wasTruncated;
        return data;
    }
}

export interface IBulkInvitationValidationResult {
    validEmails: string[];
    invalidEmails: string[];
    totalEmailsParsed: number;
    wasTruncated: boolean;
}

export class SendBulkInvitesRequest implements ISendBulkInvitesRequest {
    emails!: string[];
    includeInvited!: boolean;

    constructor(data?: ISendBulkInvitesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            this.includeInvited = _data["includeInvited"];
        }
    }

    static fromJS(data: any): SendBulkInvitesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendBulkInvitesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        data["includeInvited"] = this.includeInvited;
        return data;
    }
}

export interface ISendBulkInvitesRequest {
    emails: string[];
    includeInvited: boolean;
}

export class BulkEmailJobStatusResponse implements IBulkEmailJobStatusResponse {
    jobType!: EmailJobType;
    status!: BulkEmailJobStatus;
    totalEmails!: number;
    successfulEmails!: number;
    failedEmails!: number;
    errorMessage!: string | undefined;

    constructor(data?: IBulkEmailJobStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobType = _data["jobType"];
            this.status = _data["status"];
            this.totalEmails = _data["totalEmails"];
            this.successfulEmails = _data["successfulEmails"];
            this.failedEmails = _data["failedEmails"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): BulkEmailJobStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BulkEmailJobStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobType"] = this.jobType;
        data["status"] = this.status;
        data["totalEmails"] = this.totalEmails;
        data["successfulEmails"] = this.successfulEmails;
        data["failedEmails"] = this.failedEmails;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IBulkEmailJobStatusResponse {
    jobType: EmailJobType;
    status: BulkEmailJobStatus;
    totalEmails: number;
    successfulEmails: number;
    failedEmails: number;
    errorMessage: string | undefined;
}

export enum EmailJobType {
    Invite = 0,
    PasswordReset = 1,
}

export enum BulkEmailJobStatus {
    Pending = 0,
    Processing = 1,
    Completed = 2,
    Failed = 3,
}

/** The draft (unsaved) invite-email body to render for preview. Null/blank renders the default copy. Sender name/email/subject are intentionally omitted — they don't affect the rendered body HTML. BulletsEnabled mirrors the master feature-bullets toggle (null/true = show the per-section gated bullets; false = render none) so the preview reflects the toggle live. */
export class InviteEmailPreviewRequest implements IInviteEmailPreviewRequest {
    body!: string | undefined;
    bulletsEnabled!: boolean | undefined;

    constructor(data?: IInviteEmailPreviewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.body = _data["body"];
            this.bulletsEnabled = _data["bulletsEnabled"];
        }
    }

    static fromJS(data: any): InviteEmailPreviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviteEmailPreviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body;
        data["bulletsEnabled"] = this.bulletsEnabled;
        return data;
    }
}

/** The draft (unsaved) invite-email body to render for preview. Null/blank renders the default copy. Sender name/email/subject are intentionally omitted — they don't affect the rendered body HTML. BulletsEnabled mirrors the master feature-bullets toggle (null/true = show the per-section gated bullets; false = render none) so the preview reflects the toggle live. */
export interface IInviteEmailPreviewRequest {
    body: string | undefined;
    bulletsEnabled: boolean | undefined;
}

export class AgreementStatus implements IAgreementStatus {
    hasAccepted!: boolean;
    latestVersion!: number | undefined;

    constructor(data?: IAgreementStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasAccepted = _data["hasAccepted"];
            this.latestVersion = _data["latestVersion"];
        }
    }

    static fromJS(data: any): AgreementStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAccepted"] = this.hasAccepted;
        data["latestVersion"] = this.latestVersion;
        return data;
    }
}

export interface IAgreementStatus {
    hasAccepted: boolean;
    latestVersion: number | undefined;
}

export class Agreement implements IAgreement {
    id!: number;
    version!: number;
    effectiveAt!: Date;
    body!: string;

    constructor(data?: IAgreement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.version = _data["version"];
            this.effectiveAt = _data["effectiveAt"] ? new Date(_data["effectiveAt"].toString()) : undefined as any;
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): Agreement {
        data = typeof data === 'object' ? data : {};
        let result = new Agreement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["version"] = this.version;
        data["effectiveAt"] = this.effectiveAt ? this.effectiveAt.toISOString() : undefined as any;
        data["body"] = this.body;
        return data;
    }
}

export interface IAgreement {
    id: number;
    version: number;
    effectiveAt: Date;
    body: string;
}

export class AcceptLegalAgreementRequest implements IAcceptLegalAgreementRequest {
    agreementId!: number;

    constructor(data?: IAcceptLegalAgreementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agreementId = _data["agreementId"];
        }
    }

    static fromJS(data: any): AcceptLegalAgreementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptLegalAgreementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agreementId"] = this.agreementId;
        return data;
    }
}

export interface IAcceptLegalAgreementRequest {
    agreementId: number;
}

export class CreateLinkResponse implements ICreateLinkResponse {
    url!: string;

    constructor(data?: ICreateLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): CreateLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface ICreateLinkResponse {
    url: string;
}

export class CreateLinkRequest implements ICreateLinkRequest {
    entityId!: string;
    entityType!: LinkEntityType;
    expiration!: Date;
    tenantName!: string;
    recipient!: string | undefined;

    constructor(data?: ICreateLinkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.entityType = _data["entityType"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : undefined as any;
            this.tenantName = _data["tenantName"];
            this.recipient = _data["recipient"];
        }
    }

    static fromJS(data: any): CreateLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["entityType"] = this.entityType;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : undefined as any;
        data["tenantName"] = this.tenantName;
        data["recipient"] = this.recipient;
        return data;
    }
}

export interface ICreateLinkRequest {
    entityId: string;
    entityType: LinkEntityType;
    expiration: Date;
    tenantName: string;
    recipient: string | undefined;
}

export enum LinkEntityType {
    Unknown = 0,
    Statement = 1,
    SignableDocument = 2,
}

export class SuccessfulAuthenticationResponse implements ISuccessfulAuthenticationResponse {
    type!: LoginType;
    /** Opaque MFA session token. Only set when Type is MfaRequired. */
    mfaSessionToken!: string | undefined;
    /** Length of the MFA verification code. Only set when Type is MfaRequired. */
    mfaCodeLength!: number | undefined;
    /** MFA code lifetime in minutes. Only set when Type is MfaRequired. */
    mfaCodeLifetimeMinutes!: number | undefined;
    /** MFA resend cooldown in seconds. Only set when Type is MfaRequired. */
    mfaResendCooldownSeconds!: number | undefined;
    /** The contact method used to deliver the MFA code. Only set when Type is MfaRequired.
Nullable so old clients that don't read it default to the email experience. */
    mfaContactMethod!: ContactMethod | undefined;

    constructor(data?: ISuccessfulAuthenticationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.mfaSessionToken = _data["mfaSessionToken"];
            this.mfaCodeLength = _data["mfaCodeLength"];
            this.mfaCodeLifetimeMinutes = _data["mfaCodeLifetimeMinutes"];
            this.mfaResendCooldownSeconds = _data["mfaResendCooldownSeconds"];
            this.mfaContactMethod = _data["mfaContactMethod"];
        }
    }

    static fromJS(data: any): SuccessfulAuthenticationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SuccessfulAuthenticationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["mfaSessionToken"] = this.mfaSessionToken;
        data["mfaCodeLength"] = this.mfaCodeLength;
        data["mfaCodeLifetimeMinutes"] = this.mfaCodeLifetimeMinutes;
        data["mfaResendCooldownSeconds"] = this.mfaResendCooldownSeconds;
        data["mfaContactMethod"] = this.mfaContactMethod;
        return data;
    }
}

export interface ISuccessfulAuthenticationResponse {
    type: LoginType;
    /** Opaque MFA session token. Only set when Type is MfaRequired. */
    mfaSessionToken: string | undefined;
    /** Length of the MFA verification code. Only set when Type is MfaRequired. */
    mfaCodeLength: number | undefined;
    /** MFA code lifetime in minutes. Only set when Type is MfaRequired. */
    mfaCodeLifetimeMinutes: number | undefined;
    /** MFA resend cooldown in seconds. Only set when Type is MfaRequired. */
    mfaResendCooldownSeconds: number | undefined;
    /** The contact method used to deliver the MFA code. Only set when Type is MfaRequired.
Nullable so old clients that don't read it default to the email experience. */
    mfaContactMethod: ContactMethod | undefined;
}

export enum LoginType {
    Restricted = 1,
    Full = 2,
    MfaRequired = 3,
}

export enum ContactMethod {
    Email = 0,
    PhoneNumber = 1,
}

export class MicrosoftAuthOptionsResponse implements IMicrosoftAuthOptionsResponse {
    clientId!: string;
    authority!: string;
    redirectUri!: string;

    constructor(data?: IMicrosoftAuthOptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.authority = _data["authority"];
            this.redirectUri = _data["redirectUri"];
        }
    }

    static fromJS(data: any): MicrosoftAuthOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftAuthOptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["authority"] = this.authority;
        data["redirectUri"] = this.redirectUri;
        return data;
    }
}

export interface IMicrosoftAuthOptionsResponse {
    clientId: string;
    authority: string;
    redirectUri: string;
}

export class AuthenticationInfo implements IAuthenticationInfo {
    username!: string;
    password!: string;
    keepSigned!: boolean;

    constructor(data?: IAuthenticationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.keepSigned = _data["keepSigned"];
        }
    }

    static fromJS(data: any): AuthenticationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["keepSigned"] = this.keepSigned;
        return data;
    }
}

export interface IAuthenticationInfo {
    username: string;
    password: string;
    keepSigned: boolean;
}

export class MfaVerificationRequest implements IMfaVerificationRequest {
    mfaSessionToken!: string;
    code!: string;
    keepSigned!: boolean;

    constructor(data?: IMfaVerificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mfaSessionToken = _data["mfaSessionToken"];
            this.code = _data["code"];
            this.keepSigned = _data["keepSigned"];
        }
    }

    static fromJS(data: any): MfaVerificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MfaVerificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mfaSessionToken"] = this.mfaSessionToken;
        data["code"] = this.code;
        data["keepSigned"] = this.keepSigned;
        return data;
    }
}

export interface IMfaVerificationRequest {
    mfaSessionToken: string;
    code: string;
    keepSigned: boolean;
}

export class ResendMfaCodeRequest implements IResendMfaCodeRequest {
    mfaSessionToken!: string;

    constructor(data?: IResendMfaCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mfaSessionToken = _data["mfaSessionToken"];
        }
    }

    static fromJS(data: any): ResendMfaCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResendMfaCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mfaSessionToken"] = this.mfaSessionToken;
        return data;
    }
}

export interface IResendMfaCodeRequest {
    mfaSessionToken: string;
}

export class UserInfo implements IUserInfo {
    userId!: number;
    userName!: string;
    propertyOwnerType!: PropertyOwnerType;
    loginType!: LoginType;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.propertyOwnerType = _data["propertyOwnerType"];
            this.loginType = _data["loginType"];
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["propertyOwnerType"] = this.propertyOwnerType;
        data["loginType"] = this.loginType;
        return data;
    }
}

export interface IUserInfo {
    userId: number;
    userName: string;
    propertyOwnerType: PropertyOwnerType;
    loginType: LoginType;
}

export enum PropertyOwnerType {
    Commercial = 1,
    Residential = 2,
}

export class InviteRequest implements IInviteRequest {
    contactValue!: string;

    constructor(data?: IInviteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactValue = _data["contactValue"];
        }
    }

    static fromJS(data: any): InviteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactValue"] = this.contactValue;
        return data;
    }
}

export interface IInviteRequest {
    contactValue: string;
}

export class ValidatedInvitation implements IValidatedInvitation {
    contactValue!: string | undefined;
    contactMethod!: ContactMethod;

    constructor(data?: IValidatedInvitation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactValue = _data["contactValue"];
            this.contactMethod = _data["contactMethod"];
        }
    }

    static fromJS(data: any): ValidatedInvitation {
        data = typeof data === 'object' ? data : {};
        let result = new ValidatedInvitation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactValue"] = this.contactValue;
        data["contactMethod"] = this.contactMethod;
        return data;
    }
}

export interface IValidatedInvitation {
    contactValue: string | undefined;
    contactMethod: ContactMethod;
}

export class UserTokenRegistration implements IUserTokenRegistration {
    user!: UserRegistration;
    invitationToken!: string;

    constructor(data?: IUserTokenRegistration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserRegistration.fromJS(_data["user"]) : undefined as any;
            this.invitationToken = _data["invitationToken"];
        }
    }

    static fromJS(data: any): UserTokenRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new UserTokenRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["invitationToken"] = this.invitationToken;
        return data;
    }
}

export interface IUserTokenRegistration {
    user: UserRegistration;
    invitationToken: string;
}

export class UserRegistration implements IUserRegistration {
    userName!: string;
    password!: string;

    constructor(data?: IUserRegistration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UserRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new UserRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IUserRegistration {
    userName: string;
    password: string;
}

export class CustomerInvitationResult implements ICustomerInvitationResult {
    invitations!: CustomerInvitation[];

    constructor(data?: ICustomerInvitationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invitations"])) {
                this.invitations = [] as any;
                for (let item of _data["invitations"])
                    this.invitations!.push(CustomerInvitation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerInvitationResult {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerInvitationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invitations)) {
            data["invitations"] = [];
            for (let item of this.invitations)
                data["invitations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICustomerInvitationResult {
    invitations: CustomerInvitation[];
}

export class CustomerInvitation implements ICustomerInvitation {
    contactValue!: string;
    inviteSentDate!: Date;
    lastSignInDate!: Date | undefined;
    status!: CustomerInvitationStatus;
    inviteLink!: string | undefined;

    constructor(data?: ICustomerInvitation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactValue = _data["contactValue"];
            this.inviteSentDate = _data["inviteSentDate"] ? new Date(_data["inviteSentDate"].toString()) : undefined as any;
            this.lastSignInDate = _data["lastSignInDate"] ? new Date(_data["lastSignInDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.inviteLink = _data["inviteLink"];
        }
    }

    static fromJS(data: any): CustomerInvitation {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerInvitation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactValue"] = this.contactValue;
        data["inviteSentDate"] = this.inviteSentDate ? this.inviteSentDate.toISOString() : undefined as any;
        data["lastSignInDate"] = this.lastSignInDate ? this.lastSignInDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["inviteLink"] = this.inviteLink;
        return data;
    }
}

export interface ICustomerInvitation {
    contactValue: string;
    inviteSentDate: Date;
    lastSignInDate: Date | undefined;
    status: CustomerInvitationStatus;
    inviteLink: string | undefined;
}

export class SendPasswordResetLinkRequest implements ISendPasswordResetLinkRequest {
    username!: string;

    constructor(data?: ISendPasswordResetLinkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): SendPasswordResetLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetLinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }
}

export interface ISendPasswordResetLinkRequest {
    username: string;
}

export class NewPasswordModel implements INewPasswordModel {
    /** The new password to set */
    newPassword!: Password;

    constructor(data?: INewPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"] ? Password.fromJS(_data["newPassword"]) : undefined as any;
        }
    }

    static fromJS(data: any): NewPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword ? this.newPassword.toJSON() : undefined as any;
        return data;
    }
}

export interface INewPasswordModel {
    /** The new password to set */
    newPassword: Password;
}

export class Password implements IPassword {
    value!: string;

    constructor(data?: IPassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Password {
        data = typeof data === 'object' ? data : {};
        let result = new Password();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IPassword {
    value: string;
}

export class UserPermissionModelV2 implements IUserPermissionModelV2 {
    id!: number | undefined;
    email!: string;
    entityId!: number;
    entityName!: string | undefined;
    entityType!: UserPermissionEntityType;
    permissionType!: UserPermissionType;
    contactExists!: boolean;

    constructor(data?: IUserPermissionModelV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.entityId = _data["entityId"];
            this.entityName = _data["entityName"];
            this.entityType = _data["entityType"];
            this.permissionType = _data["permissionType"];
            this.contactExists = _data["contactExists"];
        }
    }

    static fromJS(data: any): UserPermissionModelV2 {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionModelV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["entityId"] = this.entityId;
        data["entityName"] = this.entityName;
        data["entityType"] = this.entityType;
        data["permissionType"] = this.permissionType;
        data["contactExists"] = this.contactExists;
        return data;
    }
}

export interface IUserPermissionModelV2 {
    id: number | undefined;
    email: string;
    entityId: number;
    entityName: string | undefined;
    entityType: UserPermissionEntityType;
    permissionType: UserPermissionType;
    contactExists: boolean;
}

export enum UserPermissionEntityType {
    Customer = 1,
    Location = 2,
}

/** Wire response for the access-context endpoint. Mirrors AccessContext field-for-field, except GrantedPermission uses the SAME restricted AccessContextAccessLevel wire enum as the request (never the internal UserPermissionType), keeping that internal enum's inheritance-only sentinel member off the wire from the response side too. Collection properties are initialized to empty (never left null), so an empty resolution serializes as [] — REQ-UM-ACCESS-010 AC-2. */
export class AccessContextResponseModel implements IAccessContextResponseModel {
    accessibleCustomerIds!: number[];
    accessibleLocationIds!: number[];
    /** Raw tenant-configured business-unit allow-list for the entity type. Empty-list meaning
(allow-all vs. allow-none) is entity-dependent and is the CONSUMER's responsibility —
see AccessContext.PermittedBusinessUnitIds for the full rationale. */
    permittedBusinessUnitIds!: number[];
    /** Entity statuses the tenant allows to be shown for this entity type. Empty means unrestricted. */
    allowedStatuses!: string[];
    /** The access level that was required for this resolution (echoes the request). */
    grantedPermission!: AccessContextAccessLevel;

    constructor(data?: IAccessContextResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessibleCustomerIds"])) {
                this.accessibleCustomerIds = [] as any;
                for (let item of _data["accessibleCustomerIds"])
                    this.accessibleCustomerIds!.push(item);
            }
            if (Array.isArray(_data["accessibleLocationIds"])) {
                this.accessibleLocationIds = [] as any;
                for (let item of _data["accessibleLocationIds"])
                    this.accessibleLocationIds!.push(item);
            }
            if (Array.isArray(_data["permittedBusinessUnitIds"])) {
                this.permittedBusinessUnitIds = [] as any;
                for (let item of _data["permittedBusinessUnitIds"])
                    this.permittedBusinessUnitIds!.push(item);
            }
            if (Array.isArray(_data["allowedStatuses"])) {
                this.allowedStatuses = [] as any;
                for (let item of _data["allowedStatuses"])
                    this.allowedStatuses!.push(item);
            }
            this.grantedPermission = _data["grantedPermission"];
        }
    }

    static fromJS(data: any): AccessContextResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccessContextResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessibleCustomerIds)) {
            data["accessibleCustomerIds"] = [];
            for (let item of this.accessibleCustomerIds)
                data["accessibleCustomerIds"].push(item);
        }
        if (Array.isArray(this.accessibleLocationIds)) {
            data["accessibleLocationIds"] = [];
            for (let item of this.accessibleLocationIds)
                data["accessibleLocationIds"].push(item);
        }
        if (Array.isArray(this.permittedBusinessUnitIds)) {
            data["permittedBusinessUnitIds"] = [];
            for (let item of this.permittedBusinessUnitIds)
                data["permittedBusinessUnitIds"].push(item);
        }
        if (Array.isArray(this.allowedStatuses)) {
            data["allowedStatuses"] = [];
            for (let item of this.allowedStatuses)
                data["allowedStatuses"].push(item);
        }
        data["grantedPermission"] = this.grantedPermission;
        return data;
    }
}

/** Wire response for the access-context endpoint. Mirrors AccessContext field-for-field, except GrantedPermission uses the SAME restricted AccessContextAccessLevel wire enum as the request (never the internal UserPermissionType), keeping that internal enum's inheritance-only sentinel member off the wire from the response side too. Collection properties are initialized to empty (never left null), so an empty resolution serializes as [] — REQ-UM-ACCESS-010 AC-2. */
export interface IAccessContextResponseModel {
    accessibleCustomerIds: number[];
    accessibleLocationIds: number[];
    /** Raw tenant-configured business-unit allow-list for the entity type. Empty-list meaning
(allow-all vs. allow-none) is entity-dependent and is the CONSUMER's responsibility —
see AccessContext.PermittedBusinessUnitIds for the full rationale. */
    permittedBusinessUnitIds: number[];
    /** Entity statuses the tenant allows to be shown for this entity type. Empty means unrestricted. */
    allowedStatuses: string[];
    /** The access level that was required for this resolution (echoes the request). */
    grantedPermission: AccessContextAccessLevel;
}

/** Wire-safe access level for the access-context endpoint. Deliberately a NEW, restricted enum — NOT the internal UserPermissionType — so that internal enum's fourth, inheritance-only sentinel member can never reach the wire (REQ-UM-ACCESS-004 boundary guarantee by construction). Values are numerically aligned with the internal enum's None/Read/Billing members for a trivial 1:1 cast at the controller boundary, but this type must never be replaced by or aliased to the internal one. */
export enum AccessContextAccessLevel {
    None = 0,
    Read = 1,
    Billing = 2,
}

/** Wire request for the access-context endpoint. Mirrors AccessContextRequest field-for-field, except RequiredAccessLevel is typed as the restricted AccessContextAccessLevel wire enum (never the internal UserPermissionType), and there is intentionally NO tenant-identifying field of any kind — tenant scope is derived from the authenticated caller, never taken from the request body.            [Required] annotations here document intent and drive the generated client's Required.Always contract, but UsersController has no [ApiController], so nothing auto-validates them server-side. In practice ModelState.IsValid only rejects a missing ContactValue (the one reference-type field bound from JSON) — the value-type fields (EntityType, RequiredAccessLevel) default to their zero member when omitted, and the collections are non-null by initializer, so omitting any of those does NOT produce a 400. */
export class AccessContextRequestModel implements IAccessContextRequestModel {
    /** The requesting user's contact identifier (email or canonical phone). */
    contactValue!: string;
    /** The domain entity type the caller is resolving access for. */
    entityType!: AccessContextEntityType;
    /** Minimum access level required for a customer/location to be considered accessible. */
    requiredAccessLevel!: AccessContextAccessLevel;
    /** Customer IDs the requesting user has a contact method on. */
    contactMatchedCustomerIds!: number[];
    /** Location IDs the requesting user has a contact method on. */
    contactMatchedLocationIds!: number[];
    /** Location → parent customer ID, for every location in ContactMatchedLocationIds. */
    locationParentage!: { [key: string]: number; };

    constructor(data?: IAccessContextRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.contactMatchedCustomerIds = [];
            this.contactMatchedLocationIds = [];
            this.locationParentage = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactValue = _data["contactValue"];
            this.entityType = _data["entityType"];
            this.requiredAccessLevel = _data["requiredAccessLevel"];
            if (Array.isArray(_data["contactMatchedCustomerIds"])) {
                this.contactMatchedCustomerIds = [] as any;
                for (let item of _data["contactMatchedCustomerIds"])
                    this.contactMatchedCustomerIds!.push(item);
            }
            if (Array.isArray(_data["contactMatchedLocationIds"])) {
                this.contactMatchedLocationIds = [] as any;
                for (let item of _data["contactMatchedLocationIds"])
                    this.contactMatchedLocationIds!.push(item);
            }
            if (_data["locationParentage"]) {
                this.locationParentage = {} as any;
                for (let key in _data["locationParentage"]) {
                    if (_data["locationParentage"].hasOwnProperty(key))
                        (this.locationParentage as any)![key] = _data["locationParentage"][key];
                }
            }
        }
    }

    static fromJS(data: any): AccessContextRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccessContextRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactValue"] = this.contactValue;
        data["entityType"] = this.entityType;
        data["requiredAccessLevel"] = this.requiredAccessLevel;
        if (Array.isArray(this.contactMatchedCustomerIds)) {
            data["contactMatchedCustomerIds"] = [];
            for (let item of this.contactMatchedCustomerIds)
                data["contactMatchedCustomerIds"].push(item);
        }
        if (Array.isArray(this.contactMatchedLocationIds)) {
            data["contactMatchedLocationIds"] = [];
            for (let item of this.contactMatchedLocationIds)
                data["contactMatchedLocationIds"].push(item);
        }
        if (this.locationParentage) {
            data["locationParentage"] = {};
            for (let key in this.locationParentage) {
                if (this.locationParentage.hasOwnProperty(key))
                    (data["locationParentage"] as any)[key] = (this.locationParentage as any)[key];
            }
        }
        return data;
    }
}

/** Wire request for the access-context endpoint. Mirrors AccessContextRequest field-for-field, except RequiredAccessLevel is typed as the restricted AccessContextAccessLevel wire enum (never the internal UserPermissionType), and there is intentionally NO tenant-identifying field of any kind — tenant scope is derived from the authenticated caller, never taken from the request body.            [Required] annotations here document intent and drive the generated client's Required.Always contract, but UsersController has no [ApiController], so nothing auto-validates them server-side. In practice ModelState.IsValid only rejects a missing ContactValue (the one reference-type field bound from JSON) — the value-type fields (EntityType, RequiredAccessLevel) default to their zero member when omitted, and the collections are non-null by initializer, so omitting any of those does NOT produce a 400. */
export interface IAccessContextRequestModel {
    /** The requesting user's contact identifier (email or canonical phone). */
    contactValue: string;
    /** The domain entity type the caller is resolving access for. */
    entityType: AccessContextEntityType;
    /** Minimum access level required for a customer/location to be considered accessible. */
    requiredAccessLevel: AccessContextAccessLevel;
    /** Customer IDs the requesting user has a contact method on. */
    contactMatchedCustomerIds: number[];
    /** Location IDs the requesting user has a contact method on. */
    contactMatchedLocationIds: number[];
    /** Location → parent customer ID, for every location in ContactMatchedLocationIds. */
    locationParentage: { [key: string]: number; };
}

export enum AccessContextEntityType {
    None = 0,
    Invoice = 1,
    ConsolidatedInvoice = 2,
    Job = 3,
    Estimate = 4,
    Membership = 5,
    ServiceAgreement = 6,
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}